import dayjs from "dayjs";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MobileHeader from "./components/mobile.header.component";
import LandingPage from "./pages/landing.page";
import GamesPage from "./pages/games.page";
import ContactPage from "./pages/contact.page";
import AboutPage from "./pages/about.page";
import NumberPressGamePage from "./pages/games/numberpaid/numberpair-game";
import NumberDrawGamePage from "./pages/games/numberdraw/numberpair-game";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HeaderWithConditionalHide />
        <Routes>
          <Route path="/about" element={<AboutPage />} />
          <Route path="games/2" element={<NumberDrawGamePage />} />
          <Route path="/games/1" element={<NumberPressGamePage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<LandingPage />} />
          <Route path="/" element={<LandingPage />} />
        </Routes>
        <FooterComponent />
      </BrowserRouter>
    </div>
  );
}

function HeaderWithConditionalHide() {
  const location = useLocation();
  if (location.pathname === "/games/1") return null;
  return <MobileHeader />;
}

export default App;

function FooterComponent() {
  return (
    <div className="footer p-16">
      <div className="footer-copyright">
        {" "}
        &copy; {dayjs().format("YYYY")} www.priyanath.us
      </div>
    </div>
  );
}
